import IconLoader from "../../../../src/components/app-icons.js";
import * as React from 'react';
export default {
  IconLoader,
  React
};